import { useCallback } from 'react'
import { Location, useLocation, useNavigate } from 'react-router-dom'
import { useAppType } from '../context/AppContext'
import { IProduct } from '../types/products'

export type ProductRouteState = {
  preview?: IProduct
  backgroundLocation?: Location
}

let origin: { id: string; el: HTMLElement } | null = null

export function takeProductOrigin(id: string) {
  return origin?.id === id ? origin.el : null
}

export function useOpenProduct() {
  const navigate = useNavigate()
  const location = useLocation()
  const appType = useAppType()

  return useCallback(
    (id: string, source?: HTMLElement | null, preview?: IProduct) => {
      origin = source ? { id, el: source } : null
      const state: ProductRouteState = {
        preview,
        backgroundLocation: location,
      }
      navigate(`/${appType}/product/${id}`, { state })
    },
    [navigate, location, appType],
  )
}
